"use client";

import { useEffect, useState } from "react";

/** Ticks every second while `retryAt` is in the future; 0 once it has passed (or is null). */
export function useSecondsUntil(retryAt: number | null): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!retryAt) return;

    const id = setInterval(() => {
      const current = Date.now();
      setNow(current);

      if (current >= retryAt) {
        clearInterval(id);
      }
    }, 1000);

    return () => clearInterval(id);
  }, [retryAt]);

  return retryAt ? Math.max(0, Math.ceil((retryAt - now) / 1000)) : 0;
}
